export var IncidentPriority;
(function (IncidentPriority) {
    IncidentPriority["LOW"] = "LOW";
    IncidentPriority["NORMAL"] = "NORMAL";
    IncidentPriority["MEDIUM"] = "MEDIUM";
    IncidentPriority["HIGH"] = "HIGH";
    //TODO: these latter two are functionally the same,
    //but BE currently returning different names in
    //different endpoints. Mike O is aware,
    //update this once BE is fixed
    //incidentsCounts endpoint uses 'HIGHEST',
    //incidentsList endpoint uses 'CRITICAL'
    // Should examine every use case of either once rectified
    IncidentPriority["HIGHEST"] = "HIGHEST";
    IncidentPriority["CRITICAL"] = "CRITICAL";
})(IncidentPriority || (IncidentPriority = {}));
export const IncidentPriorityRating = {
    [IncidentPriority.NORMAL]: 1,
    [IncidentPriority.LOW]: 1,
    [IncidentPriority.MEDIUM]: 2,
    [IncidentPriority.HIGH]: 3,
    [IncidentPriority.CRITICAL]: 4,
    [IncidentPriority.HIGHEST]: 4,
};
export var Status;
(function (Status) {
    Status["NEW"] = "new";
    Status["EXISTING"] = "existing";
})(Status || (Status = {}));
export var IncidentPriorityLabel;
(function (IncidentPriorityLabel) {
    IncidentPriorityLabel["NORMAL"] = "Low";
    IncidentPriorityLabel["MEDIUM"] = "Medium";
    IncidentPriorityLabel["HIGH"] = "High";
    // TODO: need to adjust with IncidentPriority.
    //Remove "HIGHEST" once BE is fixed
    IncidentPriorityLabel["HIGHEST"] = "Critical";
    IncidentPriorityLabel["CRITICAL"] = "Critical";
})(IncidentPriorityLabel || (IncidentPriorityLabel = {}));
export var IncidentStatus;
(function (IncidentStatus) {
    IncidentStatus["ACTIVE"] = "ACTIVE";
    IncidentStatus["RESOLVED"] = "RESOLVED";
})(IncidentStatus || (IncidentStatus = {}));
export var IncidentStatusLabel;
(function (IncidentStatusLabel) {
    IncidentStatusLabel["ACTIVE"] = "Active";
    IncidentStatusLabel["RESOLVED"] = "Resolved";
})(IncidentStatusLabel || (IncidentStatusLabel = {}));
